import importerReducers from '../../../modules/shared/importer/importerReducers'
import actions from '../../../modules/courseCategory/importer/courseCategoryImporterActions'

export default importerReducers(actions)
